import { t } from '@trimble/i18n';
import { FilterHandlerRecord as GenericFilterHandlerRecord } from '@trimble/ui-components/solidjs';

export type ProjectDataFilterMode = 'all' | 'active' | 'archived';

export interface FilterOption<K> {
  key: K;
  label: string;
}

export type FilterHandlerRecord<T> = GenericFilterHandlerRecord<
  T,
  ProjectDataFilterMode
>;

export const PROJECT_DATA_FILTER_OPTIONS: () => FilterOption<ProjectDataFilterMode>[] =
  () => [
    {
      key: 'all',
      label: t('mobileMapping.projectData.filterOptions.everythingInProject'),
    },
    {
      key: 'active',
      label: t('mobileMapping.projectData.filterOptions.activeData'),
    },
    {
      key: 'archived',
      label: t('mobileMapping.projectData.filterOptions.archivedData'),
    },
  ];
